import {Component, OnDestroy, OnInit} from '@angular/core';
import {CustomFormControl} from '../custom-form-control';
import {Observable, Subscription} from 'rxjs';
import {BrandsState} from '../../../../state/brands/brands.state';
import {Select, Store} from '@ngxs/store';
import {BrandsActions} from '../../../../state/brands/brands.actions';
import {debounceTime} from 'rxjs/operators';
import {DEBOUNCE_TIME} from '../../../../helpers/form.helper';

@Component({
    selector: 'app-autocomplete-brand',
    templateUrl: './autocomplete-brand.component.html'
})
export class AutocompleteBrandComponent extends CustomFormControl implements OnInit, OnDestroy {
    @Select(BrandsState.brandSearchList) suggestions$: Observable<string[]>;

    private subscriptions: Subscription = new Subscription();

    constructor(private store: Store) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.control.valueChanges
                .pipe(debounceTime(DEBOUNCE_TIME))
                .subscribe(
                    (codeSearch) => {
                        if (!!codeSearch) {
                            this.store.dispatch(new BrandsActions.BrandsSearchList({codeSearch}));
                        }
                    }
                )
        );
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

}
